<template>
	<div
		:class="['panel', 'audience',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div class="container">
			<div
				v-if="isHeaderVisible"
				:class="[
					'panel_header',
					isBrand? 'sk' : '',
				]"
			>
				<div class="row align-items-end">
					<div class="col-12">
						<h2 v-if="block.block_title === null">
							Посмотрите, как это было
						</h2>
						<h2 v-else>
							{{ block.block_title }}
						</h2>
					</div>
				</div>
			</div>
			<client-only placeholder="Галерея">
				<div v-b-visible.once="onGalleryVisible" class="gallery_block">
					<div v-if="showGallery" v-msnry class="row grid">
						<div
							v-for="(image, imageIndex) in preview"
							:key="imageIndex"
							class="col-12 col-md-6 col-lg-4 grid-item"
						>
							<div class="gallery-item">
								<img :src="image.url_c" :alt="image.title" @click="setIndex(imageIndex)">
							</div>
						</div>
					</div>

					<CoolLightBox
						:items="imageSources"
						:full-screen="true"
						:index="index"
						loop
						@close="index = null"
					/>
				</div>
			</client-only>
			<div v-if="isFooterVisible && photo.length > perPreview" class="panel_footer">
				<div class="row">
					<div class="col-12">
						<button class="btn btn-primary" @click="setIndex(perPreview)">
							{{ $t('allPhoto') }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox';
import panel from '~/mixins/panel';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

export default {
	name: 'GalleryBlock',
	components: {
		CoolLightBox,
	},
	directives: {
		msnry: {
			bind() {
				// eslint-disable-next-line no-unused-expressions
				import(/* webpackChunkName: "masonry" */'masonry-layout');
				// eslint-disable-next-line no-unused-expressions
				import(/* webpackChunkName: "masonry" */'imagesloaded');
			},
			async componentUpdated(element, bindings, vnode) {
				const Masonry = (await import(/* webpackChunkName: "masonry" */'masonry-layout')).default;
				const imagesLoaded = (await import(/* webpackChunkName: "masonry" */'imagesloaded')).default;

				const component = vnode.context;

				imagesLoaded(element, () => {
					component.msnry = new Masonry(element, {
						itemSelector: '.grid-item',
					});
				});
			},
			unbind(element, bindings, vnode) {
				const component = vnode.context;
				if (component.msnry) {
					component.msnry.destroy();
				}
			},
		},
	},
	mixins: [panel],
	data() {
		return {
			showGallery: false,
			images: null,
			index: null,
			perPreview: 6,
		};
	},
	computed: {
		photo() {
			if (this.images && Array.isArray(this.images.photo)) {
				return this.images.photo;
			}

			return [];
		},
		preview() {
			return this.photo.slice(0, this.perPreview);
		},
		imageSources() {
			return this.photo.map((item) => item.url_h || item.url_z);
		},
	},
	mounted() {
		this.$axios({
			method: 'get',
			url: 'https://api.flickr.com/services/rest',
			params: {
				method: 'flickr.photosets.getPhotos',
				api_key: process.env.flickrApiKey,
				photoset_id: this.block.album_id,
				extras: 'url_z, url_h, url_c, owner_name, date_taken, views',
				page: 1,
				format: 'json',
				nojsoncallback: 1,
				per_page: 36,
			},
		}).then((response) => { this.images = response.data.photoset; });
	},
	methods: {
		onGalleryVisible(visible) {
			if (visible) {
				this.showGallery = true;
			}
		},
		setIndex(index) {
			this.index = index;
		},
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/prog-flickr";
</style>
